<script>
    import Box from './Box.svelte'
    import Activity from './Activity.svelte'
    import EmojiSelector from 'svelte-emoji-selector';
    import GoogleForm from 'google-form-send'
    import { createEventDispatcher } from 'svelte';
    import Icon from 'fa-svelte'
    import { faPaperPlane as paperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane'

    let activity = ''
    let emoji = ''
    let placeholder = "Enter activity"
    let instructions = ""
    let link = ""
    let addInstructions = false

    let shakingActivityInput = false
    let shakingEmojiInput = false

    const maxActivityLength = 75
    const maxInstructionsLength = 150

    $: formFilled = (activity != '') && (emoji != '') && (link == '' || validURL(link))

    const dispatch = createEventDispatcher();
    
    function onEmoji(event) {
        emoji = event.detail;
    }

    // Google Form Submit
    let submitForm = new GoogleForm('https://cors-anywhere.herokuapp.com/https://docs.google.com/forms/d/e/1FAIpQLSdUEt3ceQeChzf-iGv0qutl9H7b1TrhQnx07wR0Ucua43m00Q/viewform')
	
	async function submitActivity() {
        if (activity == '') {
            shakingActivityInput = true
            setTimeout(function () { shakingActivityInput = false }, 500)
        }
        else if (emoji == '') {
            shakingEmojiInput = true
            setTimeout(function () { shakingEmojiInput = false }, 500)
        }
        else {
            let data = {
            'entry.2132294371': activity.trim(),
            'entry.273138099': emoji,
            'entry.1889650311': localStorage['userID'],
            'entry.86728100': 'activity_' + Math.random().toString(36).substr(2, 9),
            }

            if (instructions != '') data['entry.1141363247'] = instructions.trim()
            if (link != '') data['entry.452161038'] = (link.startsWith('http') ? link : 'https://' + link)

            dispatch('submitting')

            submitForm.setAllFields(data)

            setTimeout(function () { submit(submitForm) }, 50)
        }
    }

    async function submit(submitForm) {
        submitForm.send(false)
            
        setTimeout(dispatch('submitSuccessful'), 200)
    }
    
    function clickCancel() {
        dispatch('cancel')
    }

    function validURL(str) {
        // source: https://stackoverflow.com/questions/161738/what-is-the-best-regular-expression-to-check-if-a-string-is-a-valid-url
        // other source: https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
        const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
    }
    

</script>

<style>

main {
    display: grid;
    align-content: center;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 25rem), 1fr));
    grid-gap: 1rem 2rem;
}

.low-opacity {
    opacity: 50%;
}

inputs {
    display: grid;
    grid-gap: 0.75rem;
    z-index: 1;
    align-content: stretch;
}

.title {
    grid-column: 1 / -1;
    align-self: stretch;
    transform: translate(-0.25rem);
    margin: 0;
}

.inputPanel {
    align-self: end;
    margin: 0;
}

.backButton {
    font-size: 1.3rem;
    border-radius: 3rem;
    padding: 0.25rem;
}

.backButton:hover {
    background-color: transparent;
    color: #7539ff;
    transform: translate(-0.5rem)
}

.submitButton {
    align-self: end;
    height: auto;
}

.activityPreviewPanel {
    display: grid;
    grid-row-gap: 0.75rem;
    grid-template-rows: 1fr auto;
}

.activityCard {
    align-self: stretch;
}

button:disabled, button[disabled]{
    background-color: #bebbc5;
    color: #f6f6f6;
}

button:disabled:hover, button[disabled]:hover{
    transform: initial;
    box-shadow: none;
    cursor: not-allowed;
}

icon {
    vertical-align: middle;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}

.shaking {
    animation: shake 0.5s;
    animation-iteration-count: infinite;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

</style>

<Box hoverable={false}>
    <main>
        <h3 class='title'>
            <button on:click={clickCancel} class='backButton gray'>&lt</button> 
            Submit an activity
        </h3>
        <inputs>
            <input class:shaking = {shakingEmojiInput} class='inputPanel' maxlength="{maxActivityLength}" placeholder="{placeholder}" bind:value={activity}/>
            <!-- <p>{activity.length}/{maxActivityLength}</p> -->
            <p class:shaking = {shakingActivityInput} class='inputPanel'><EmojiSelector class='emoji_selector' on:emoji={onEmoji} /></p>
            <textarea class='inputPanel' maxlength="{maxInstructionsLength}" placeholder="Add instructions (optional)" bind:value={instructions}/>
            <!-- <p>{instructions.length}/{maxInstructionsLength}</p> -->
            <input class='inputPanel' maxlength="100" placeholder="Attach link (optional)" bind:value={link}/>
        </inputs>
        <div class='activityPreviewPanel'>
            <div class='activityCard'>
                <Box hoverable={false}>
                    {#if (activity == '')}
                    <h3 class='low-opacity'>{emoji} {placeholder}</h3>
                    {:else}
                    <h3>{emoji} {activity}</h3>
                    {/if}
                    <p>{instructions}
                    {#if (link != '')}
                     <a target="_blank" href={(link.startsWith('http') ? link : 'https://' + link)}>Start here</a>
                    {/if}
                    </p>
                </Box>
            </div>
            <button class='primary submitButton' disabled={!formFilled} on:click={submitActivity}><icon><Icon icon={paperPlane}></Icon></icon>Submit</button>
        </div>
    </main>
</Box>